import { Outlet, useMatches, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { trackPageView } from '~libs';
import { Navbar } from './NavBar';

const RouteTelemetry = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const matches = useMatches();
  const leafMatch = matches.at(-1);

  const routeId = leafMatch?.routeId;
  const routeTemplate = !routeId ? undefined : routeId.startsWith('/') ? routeId : `/${routeId}`;

  useEffect(() => {
    trackPageView({
      pathname,
      routeId,
      routeTemplate,
    });
  }, [routeId, pathname, routeTemplate]);

  return null;
};

const RootLayout = () => {
  return (
    <div className="flex h-screen flex-col">
      <RouteTelemetry />
      <Navbar />
      <main className="group/main flex h-full min-h-0 overflow-y-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export { RootLayout };
